import React, { PureComponent } from 'react'
import { Route, Switch } from 'react-router-dom'
import Kit from '../components/Kit.js'

class KitsRouter extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="kits-body">
        <Switch>
          <Route path={'/kit'}>
            <Kit />
          </Route>
        </Switch>
      </div>
    )
  }
}

export default KitsRouter
